import {
  COLLEGES,
  COLLEGE_ID,
  DEPARTMENTS,
  DEPARTMENT_ID,
  IDENTIFY_USER_EXIST_ON_DEVICE_FAIL,
  IDENTIFY_USER_EXIST_ON_DEVICE_START,
  LOGIN_FAILURE,
  LOGIN_START,
  LOGIN_SUCCESS, LOGOUT_FAIL,
  LOGOUT_START,
  LOGOUT_SUCCESS,
  RESET_STATE,
} from '../actionConstants';
import {persistor} from '../store/configureStore';

export const updateCollegeId = payload => async dispatch => {
  dispatch({
    type: COLLEGE_ID,
    payload: payload,
  });
};

export const updateDeptId = payload => async dispatch => {
  dispatch({
    type: DEPARTMENT_ID,
    payload: payload,
  });
};

export const collegeData = payload => async dispatch => {
  dispatch({
    type: COLLEGES,
    payload: payload,
  });
};

export const alldepartmentData = payload => async dispatch => {
  dispatch({
    type: DEPARTMENTS,
    payload: payload,
  });
};

export const loginStart = payload => async dispatch => {
  dispatch({
    type: LOGIN_START,
    payload: payload,
  });
};

export const loginSuccess = payload => async dispatch => {
  dispatch({
    type: LOGIN_SUCCESS,
    payload: payload,
  });
};

export const loginFailure = payload => async dispatch => {
  dispatch({
    type: LOGIN_FAILURE,
    payload: payload,
  });
};

export const logoutStart = () => async dispatch => {

  try {
    dispatch({type: LOGOUT_START});
    // Purge persisted store to clear local storage
    await persistor.purge();
    dispatch({type: LOGOUT_SUCCESS});
  } catch (error) {
    dispatch({type: LOGOUT_FAIL, payload: error.message});
  }
};

export const logoutSuccess = payload => async dispatch => {
  dispatch({
    type: LOGOUT_SUCCESS,
    payload: payload,
  });
};

export const logoutFail = payload => async dispatch => {
  dispatch({
    type: LOGOUT_FAIL,
    payload: payload,
  });
};

export const identifyUserExistOnDeviceStart = () => dispatch => {
  dispatch({
    type: IDENTIFY_USER_EXIST_ON_DEVICE_START,
  });
};

export const identifyUserExistOnDeviceSuccessful = payload => dispatch => {
  dispatch({
    type: IDENTIFY_USER_EXIST_ON_DEVICE_START,
    payload: payload,
  });
};

export const identifyUserExistOnDeviceFail = payload => dispatch => {
  dispatch({
    type: IDENTIFY_USER_EXIST_ON_DEVICE_FAIL,
    payload: payload,
  });
};

export const resetState = () => async dispatch => {
  dispatch({
    type: RESET_STATE,
  });
};
